import IStation from "../../shared/IStation";
import Spinner from "../ui/Spinner/Spinner";
import ErrorsAlert from "../ErrorsAlert/ErrorsAlert";
import { useSortBy } from "../../hooks/useSortBy";
import Accordion from "../ui/Accordion/Accordion";
import Table from "../ui/Table/Table";

interface IProps {
  stations?: IStation[];
  isPending: boolean;
  isError: boolean;
  error: any;
}

const StationsList: React.FC<IProps> = ({
  stations,
  isPending,
  isError,
  error,
}) => {
  const sortFunction = (station: IStation, field: string) => {
    const val = (station as any)[field];
    return typeof val === "string" ? val.toLowerCase() : val;
  };

  const { sorted } = useSortBy(stations, sortFunction);

  if (isPending) return <Spinner />;
  if (isError) return <ErrorsAlert errors={error?.messages} />;
  if (!stations || stations.length === 0) return <p>No stations found.</p>;

  return (
    <div>
      {sorted.map((s) => (
        <Accordion
          key={s.code}
          text={
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "80px 1fr 50px",
                width: "100%",
                gap: "1rem",
              }}
            >
              <strong>{s.code}</strong>
              <span>{s.name}</span>
            </div>
          }
          withContentPadding
          style={{ marginBottom: "0.5rem", borderBottom: "1px solid #eee" }}
        >
          <div
            style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "2rem" }}
          >
            <div>
              <h4>Contact & Location</h4>
              <p>
                <strong>Address:</strong> {s.address}, {s.zip} {s.city}
              </p>
              <p>
                <strong>Country:</strong> {s.country} ({s.countryCode})
              </p>
              <p>
                <strong>Phone:</strong> {s.phone}
              </p>
              {/* {s.email && ( */}
                <p>
                  <strong>Email (not updated from Wheels):</strong>{" "}
                  <a href={`mailto:${s.email}`}>{s.email}</a>
                </p>
              {/* )} */}
              <p>
                <strong>Coordinates:</strong> {s.lat}, {s.lon}
              </p>
              <p>
                <strong>Time Zone:</strong> {s.timeZone}
              </p>
              {s.businessName && (
                <>
                  <h4 style={{ marginTop: "1rem" }}>Business Details (not updated from Wheels)</h4>
                  <p>
                    <strong>Name:</strong> {s.businessName}
                  </p>
                  {s.businessId && (
                    <p>
                      <strong>Business ID:</strong> {s.businessId}
                    </p>
                  )}
                  {s.businessAddress && (
                    <p>
                      <strong>Address:</strong> {s.businessAddress}{s.businessAddress2 && `, ${s.businessAddress2}`}
                    </p>
                  )}
                </>
              )}
            </div>
            <div>
              <h4>Station Details</h4>
              <p>
                <strong>Type:</strong> {s.stationType}
              </p>
              <p>
                <strong>Active:</strong> {s.active ? "Yes" : "No"}
              </p>
              <p>
                <strong>Tax:</strong> {s.tax1Percent}% ({s.tax1Name})
              </p>

              {s.operationHours && s.operationHours.length > 0 && (
                <>
                  <h4 style={{ marginTop: "1rem" }}>Operation Hours</h4>
                  <Table>
                    <thead>
                      <tr>
                        <th>Day</th>
                        <th>Status</th>
                        <th>Hours</th>
                      </tr>
                    </thead>
                    <tbody>
                      {s.operationHours.map((oh) => (
                        <tr key={oh.day}>
                          <td>{oh.day}</td>
                          <td>
                            {oh.closed ? (
                              <span style={{ color: "red" }}>Closed</span>
                            ) : (
                              "Open"
                            )}
                          </td>
                          <td>
                            {oh.closed ? "-" : `${oh.opensAt} - ${oh.closesAt}`}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </>
              )}
            </div>
          </div>
        </Accordion>
      ))}
    </div>
  );
};

export default StationsList;
